import type { ReactNode } from 'react';

import { Highlight } from '../Highlight';

type FormConfig = Record<string, string | string[]>;
export type Forms = Record<string, Record<string, FormConfig>>;

interface FormsCellProps {
  forms: Forms;
  host: string;
  filter: string;
}

export function FormsCell({ forms, host, filter }: FormsCellProps) {
  const formsList = Object.keys(forms).map((form) => {
    const pages = Object.keys(forms[form]);
    const pagesList = pages.map((page) => {
      const config = forms[form][page];
      const configList = Object.keys(config).map((key) => {
        const value = config[key];
        let content: ReactNode;
        if (Array.isArray(value)) {
          content = (
            <>
              {key}:{' '}
              <ul>
                {value.map((item) => (
                  <li key={item}>{JSON.stringify(item)}</li>
                ))}
              </ul>
            </>
          );
        } else if (key === 'primaryColor') {
          content = (
            <div className="primary-color">
              {key}:{' '}
              <span className="primary-color__inner">
                <span
                  className="color-preview"
                  style={{
                    backgroundColor: value,
                  }}
                />
                {value}
              </span>
            </div>
          );
        } else {
          content = (
            <>
              {key}: {JSON.stringify(value)}
            </>
          );
        }

        return <li key={key}>{content}</li>;
      });

      return (
        <li key={page}>
          <a href={`https://${host}/${page}`} target="_blank" rel="noreferrer">
            {page}
          </a>
          <ul>{configList}</ul>
        </li>
      );
    });

    return (
      <li key={form}>
        <Highlight text={form} highlight={filter} />
        <ul>{pagesList}</ul>
      </li>
    );
  });

  return <ul>{formsList}</ul>;
}
